import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import TopNavbar from '../nav/TopNav';
import './Login.css';

const StyledBurger = styled.div`
  .btn-block {
    background: var(--primary-color);
    color: var(--black-color);
    border: 1.5px solid var(--black-color);
  }
`;

const LoginAccount = () => {
  const [users, setUser] = useState({
    email: '',
    password: '',
  });

  const { email, password } = users;

  const onChange = (e) =>
    setUser({ ...users, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <StyledBurger>
      <div className='Accounts-bg'>
        <TopNavbar />
        <div className='form_block'>
          <div className='form_block--sub'>
            <div className='form_block--heading'>
              <p>Login</p>
            </div>
            <div>
              <form onSubmit={onSubmit}>
                <div className='form-input-email'>
                  <label htmlFor='email'>Email </label>
                  <input
                    type='email'
                    name='email'
                    value={email}
                    onChange={onChange}
                    required
                  />
                </div>{' '}
                <div className='form-input-password'>
                  <label htmlFor='password' className='form_label-space'>
                    Password
                    <span>
                      <NavLink to='/'>Forgot?</NavLink>
                    </span>
                  </label>
                  <input
                    type='password'
                    name='password'
                    value={password}
                    onChange={onChange}
                    required
                  />
                </div>
                <div className='form-input-submit'>
                  <NavLink to='/user/address'>
                    <button type='submit' className='btn btn-black'>
                      Sign in
                    </button>
                  </NavLink>
                </div>
              </form>
            </div>
            <div className='form_block--footer'>
              <div>
                <p>Don’t have an account?</p>
                <NavLink to='/createAccount' className='btn btn-block'>
                  Create Account
                </NavLink>
              </div>
              <div>
                <NavLink to='/shipAddGuest' className='btn btn-block'>
                  Check Out as guest
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledBurger>
  );
};

export default LoginAccount;
